import * as React from "react"
import { CustomTable } from "@/components/Tables/CustomTable"
import { getColumns } from "./DamageProductColumns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import { CrudProvider } from "@/context/crudContext"
import { useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@mui/material"
import { apiFetch } from "@/hooks/apiFetch"
import { useQueryClient } from "@tanstack/react-query"

export default function DamageProductsList() {
  return (
    <CrudProvider>
      <DamageProductsTable />
    </CrudProvider>
  )
}

function DamageProductsTable() {
  const [openModal, setOpenModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [quantity, setQuantity] = useState("")

  const handleEdit = (row) => {
    setSelectedItem(row)
    setQuantity(row.quantity || "")
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
    setSelectedItem(null)
    setQuantity("")
  }

  const queryClient = useQueryClient()
  const handleSubmit = async () => {
    await apiFetch("damage-product/adjust", {
      method: "POST",
      body: JSON.stringify({
        quantity,
        transaction_id: selectedItem.id,
      }),
    })
    handleCloseModal()
    await queryClient.invalidateQueries({
      queryKey: ["damage-products"],
    })
  }

  const columns = getColumns(handleEdit)

  return (
    <>
      <CustomTable
        columns={columns}
        apiPath="damage-products"
        action={false}
        addBtn={false}
        label="Damage Products"
      />

      {/* Modal */}
      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>Edit Damage Product</DialogTitle>
        <DialogContent>
          <TextField
            label="Quantity to IN"
            type="number"
            fullWidth
            margin="normal"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
